import { render, staticRenderFns } from "./PassSafeguardCompensation.vue?vue&type=template&id=50a0bb3a&"
import script from "./PassSafeguardCompensation.vue?vue&type=script&lang=js&"
export * from "./PassSafeguardCompensation.vue?vue&type=script&lang=js&"
import style0 from "./PassSafeguardCompensation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports